import React, { useId } from 'react';

export type RiftPreview = { riftId: number } | { location: string };
export type RiftPreviewCallback = (source: string, preview?: RiftPreview) => void;

// Rift identity is independent of black/white movement color.
export function riftIdentityStyle(id: number): React.CSSProperties {
  return { '--rift-color': ['#3b82f6', '#f97316', '#14b8a6'][id - 1] ?? '#3b82f6',
    '--rift-tint': ['hue-rotate(0deg)', 'hue-rotate(180deg) saturate(2)', 'hue-rotate(315deg) saturate(2)'][id - 1] ?? 'hue-rotate(0deg)' } as React.CSSProperties;
}

export function useRiftPreviewEvents(onPreview?: RiftPreviewCallback) {
  const id = useId();
  return (key: string, preview: RiftPreview) => ({
    onMouseEnter: () => onPreview?.(`${id}-${key}-mouse`, preview),
    onMouseLeave: () => onPreview?.(`${id}-${key}-mouse`),
    onFocus: () => onPreview?.(`${id}-${key}-focus`, preview),
    onBlur: () => onPreview?.(`${id}-${key}-focus`),
  });
}
